import React from 'react';

function Button({ title, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`bg-amber text-textColor md:text-lg text-sm rounded-3xl font-bold px-4 py-3`}
    >
      <a
        href='https://api.whatsapp.com/send?phone=970566012888'
        target='-blank'
      >
        {title}
      </a>
    </button>
  );
}

export default Button;
